import apiShipper from '../services/apiShipper';

export const getTarifaTmov = async (idCliente = '') => {
  const { data } = await apiShipper.get('/tarifa-cliente-tmov', {
    params: {
      idCliente,
    },
  });

  const isPercentualTmov = data.tipoTarifa === 'PERCENTUAL';
  const tarifaTmovCliente = data;
  return { isPercentualTmov, tarifaTmovCliente };
};
